module.exports = __webpack_public_path__ + "img/tournaments_320.9d29521d.png";